<script setup lang="ts">
import { computed } from "vue";
import Icon from "./Icon.vue";

const props = defineProps<{
  icon?: string;
  selected?: boolean;
  selectable?: boolean;
  removable?: boolean;
}>();
const emit = defineEmits<{ click: [MouseEvent]; remove: [MouseEvent] }>();

const cls = computed(() => [
  "cw-tag",
  props.selectable ? "cw-tag--selectable" : "",
  props.selected ? "cw-tag--selected" : "",
]);

function onRemove(event: MouseEvent) {
  event.stopPropagation();
  emit("remove", event);
}
</script>
<template>
  <span
    :class="cls"
    @click="$emit('click', $event)"
  >
    <Icon
      v-if="icon"
      :name="icon"
      :size="14"
    />
    <slot />
    <button
      v-if="removable"
      type="button"
      class="cw-tag__x"
      aria-label="Entfernen"
      @click="onRemove"
    >
      <Icon
        name="x"
        :size="13"
      />
    </button>
  </span>
</template>
